import { initialState } from "./state";

export const homeworks = (state = initialState, action) => {
  switch (action.type) {
    case "SET_HOMEWORK_LIST": {
      return {
        ...state,
        homeworks: action.data,
      };
    }

    default:
      return state;
  }
};
